import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CollectionService} from '../../Services/collection.service';
import {DealersService} from '../../Services/dealers.service';
import {InvoiceDealer} from '../../Models/InvoiceDealer';
import {CollectionTransportationCost} from '../../Models/CollectionTransportationCost';
import {Property} from '../../Models/Property';
import {OptionService} from '../../Services/option.service';
import {Collection} from '../../Models/Collection';

@Component({
  selector: 'app-collection-transportation-cost',
  templateUrl: './collection-transportation-cost.component.html'
})
export class CollectionTransportationCostComponent implements OnInit {

  public collections = [];
  public collectionItems = [];
  @Input() showModal = false;
  @Input() isEdit = false;
  @Input() invoiceDealerId;
  @Input() collectionTransportationCosts: CollectionTransportationCost[] = [];
  @Input() description?: string = null;

  public properties: Property[] = [];
  @Output('closeModal') closeModal = new EventEmitter<{ closeModal: boolean, refreshData: boolean }>();
  @ViewChild('addTransportationCostModal', {static: true}) addTransportationCostModal;

  constructor(
    private collectionService: CollectionService,
    private dealersService: DealersService,
    private optionService: OptionService) {
  }

  ngOnInit() {
    this.showCollectionTransportationCostModal();
    this.optionService.getPriceMultiplier().subscribe((response) => {
      this.properties = response.data;
    });
  }

  showCollectionTransportationCostModal() {
    if (this.isEdit) {
      this.collectionTransportationCosts.forEach(collectionTransportationCost => {
        collectionTransportationCost.collection = collectionTransportationCost.collection.id;
        collectionTransportationCost.multiplier = collectionTransportationCost.multiplier.id;
      });
    } else {
      this.addCollectionTransportationCostItem();
    }
    this.collectionService.getCollection().subscribe(res => {
      this.collections = [];
      res.data.map(collection => {
        this.collectionItems.push({
          label: collection.name,
          value: collection.id
        });
        this.collections = Object.assign([], this.collectionItems);
      });
    });
    this.addTransportationCostModal.show();
  }

  hideCollectionTransportationCostModal() {
    this.showModal = false;
    this.addTransportationCostModal.hide();
    this.closeModal.emit({
      closeModal: this.showModal,
      refreshData: false
    });
  }

  addCollectionTransportationCostItem() {
    this.collectionTransportationCosts.push(new CollectionTransportationCost());
  }

  removeCollectionTransportationCostItem(i) {
    this.collectionTransportationCosts.splice(i, 1);
    this.collectionTransportationCosts = JSON.parse(JSON.stringify(this.collectionTransportationCosts));
  }

  SaveTransportationCosts() {
    const dealer = new InvoiceDealer();
    dealer.collectionTransportationCosts = JSON.parse(JSON.stringify(this.collectionTransportationCosts));
    dealer.transportationCostDescription = JSON.parse(JSON.stringify(this.description));
    this.dealersService.manageDealerCollectionTransportationCost(this.invoiceDealerId, dealer).subscribe(res => {
      this.showModal = false;
      this.addTransportationCostModal.hide();
      this.closeModal.emit({
        closeModal: this.showModal,
        refreshData: true
      });
    });
  }

  getCollections(collectionTransportationCostModel) {
    this.collections.forEach(collection => {
      collection.disabled = false;
    });

    this.collectionTransportationCosts.forEach(collectionTransportationCost => {
      this.collections.forEach(c => {
        if (c.value === collectionTransportationCost.collection && c.value !== collectionTransportationCostModel) {
          c.disabled = true;
        }
      });
    });
    return this.collections;
  }
}
